const prefix =
  "https://raw.githubusercontent.com/O-dik90/Landing_page/master/src/assets/images/logos/client/";

export default [
  {
    Id: 1,
    title: "grab",
    img: `${prefix}Grab_Logo.png`,
    height: true,
  },
  {
    Id: 2,
    title: "ovo",
    img: `${prefix}Logo OVO.png`,
    height: true,
  },
  {
    Id: 3,
    title: "fifa",
    img: `${prefix}Logo Fifa.png`,
    height: true,
  },
  {
    Id: 4,
    title: "molto",
    img: `${prefix}Logo Molto.png`,
  },
  {
    Id: 5,
    title: "telkom akses",
    img: `${prefix}Logo Telkom Akses.png`,
    height: true,
  },
  {
    Id: 6,
    title: "bank btn",
    img: `${prefix}Logo - Bank BTN.png`,
    height: true,
  },
  {
    Id: 7,
    title: "paddle pop",
    img: `${prefix}logo paddle pop.png`,
  },
  {
    Id: 8,
    title: "confidence",
    img: `${prefix}Logo confidence.png`,
  },
  // {
  //   Id: 9,
  //   title: "confidence",
  //   img: `${prefix}Logo confidence.png`,
  // },
  {
    Id: 10,
    title: "a mild",
    img: `${prefix}Logo A Mild.png`,
  },
  {
    Id: 11,
    title: "aqua",
    img: `${prefix}Logo Aqua.png`,
  },
  {
    Id: 12,
    title: "unesco",
    img: `${prefix}Logo Unesco.png`,
  },
  {
    Id: 13,
    title: "apeksi",
    img: `${prefix}Logo APEKSI.png`,
  },
  {
    Id: 14,
    title: "jakarta aquarium safari",
    img: `${prefix}Logo Jakarta Aquarium.png`,
  },
  {
    Id: 15,
    title: "kemendikbud",
    img: `${prefix}Logo Kemendikbud.png`,
  },
  // {
  //   Id: 16,
  //   title: "kuncie",
  //   img: `${prefix}Logo Kuncie.png`,
  // },

  {
    Id: 17,
    title: "bank uob",
    img: `${prefix}Logo Bank UOB.png`,
    height: true,
  },
  {
    Id: 18,
    title: "yayasan guru belajar",
    img: `${prefix}Logo Yayasan-Guru-Belajar.png`,
  },
  {
    Id: 19,
    title: "cerita guru belajar",
    img: `${prefix}Logo-Cerita-Guru-Belajar.png`,
  },
  {
    Id: 20,
    title: "nusantarum",
    img: `${prefix}Nusantarun.svg`,
  },
  {
    Id: 21,
    title: "kampus merdeka",
    img: `${prefix}Logo Kampus merdeka.png`,
  },
  {
    Id: 22,
    title: "kampus guru cikal bakal",
    img: `${prefix}Logo Kampus Guru Cikal.jpg`,
  },
  {
    Id: 23,
    title: "grapiku",
    img: `${prefix}Logo Grapiku.png`,
  },
  {
    Id: 24,
    title: "nutrifeed",
    img: `${prefix}Logo Nutrifeed.jpg`,
  },
  {
    Id: 25,
    title: "prisma",
    img: `${prefix}Logo Prisma.png`,
  },
  {
    Id: 26,
    title: "lptp",
    img: `${prefix}Logo LPTP.png`,
  },
  {
    Id: 27,
    title: "pemda boyolali",
    img: `${prefix}logo-boyolali.png`,
  },
  {
    Id: 28,
    title: "pemda klaten",
    img: `${prefix}Logo Dinak Klaten.jpg`,
  },
  {
    Id: 29,
    title: "binamarga",
    img: `${prefix}Logo Binamarga.jpg`,
  },
  {
    Id: 30,
    title: "griya aqiqah",
    img: `${prefix}Griya Aqiqah.jpg`,
  },
  {
    Id: 31,
    title: "merdeka mengajar",
    img: `${prefix}Logo Merdeka Mengajar.png`,
  },
  {
    Id: 32,
    title: "oriflame",
    img: `${prefix}Logo Oriflame.png`,
  },
  {
    Id: 33,
    title: "semua murid semua guru",
    img: `${prefix}Logo-Semua-Murid-Semua-Guru.png`,
  },
  // {
  //   Id: ,
  //   title: "",
  //   img: `${prefix}`,
  // },
];
